export const setCookieLanguage = (appCookie, locale) => {
  const expiresDay = new Date()
  expiresDay.setTime(expiresDay.getTime() + 365 * 24 * 60 * 60 * 1000)
  appCookie.set('locale', locale, {
    expires: expiresDay,
    maxAge: 60 * 60 * 24 * 365,
  })
}

export const removeCookieSessionLogin = (app) => {
  app.$cookie.remove('laAccessToken')
  app.$cookie.remove('laRefreshToken')
}

export const getAuthToken = (app) => {
  const internalToken = app.$cookie.get('laAccessToken')
  const externalToken = app.$cookie.get('accessToken')
  return {
    token: internalToken || externalToken,
    isExternal: !internalToken && !!externalToken,
    isInternal: !!internalToken,
    canRefresh: !!(internalToken && app.$cookie.get('laRefreshToken')) || !!externalToken,
  }
}

export const getCookie = (name) => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
}
